// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-StHnl";
var _3 = "leftBlock-3MG7s";
var _4 = "icon-5xNLZ";
var _5 = "title-1EjAc";
var _6 = "value-1kE_a";
var _7 = "loader-3QnQT";
var _8 = "loading-2OVYu";
export { _1 as "__esModule", _2 as "root", _3 as "leftBlock", _4 as "icon", _5 as "title", _6 as "value", _7 as "loader", _8 as "loading" }
export default { "__esModule": _1, "root": _2, "leftBlock": _3, "icon": _4, "title": _5, "value": _6, "loader": _7, "loading": _8 }
